/*-----------------------------------------------------------------
- MIXINS: Page
-----------------------------------------------------------------*/

export default {};
